import router from '../router';
import jwtDecode from 'jwt-decode';

// 청구 조합 검색 횟수
export const onGASearchCount = () => {
  console.log('onGASearchCount');
  const datalayer = window.dataLayer;
  if (router.app.$gtm.enabled()) {
    datalayer.push({
      event: 'searchCount',
    });
  }
};

// GA4 User-ID 설정
export const onGASetUserId = accessToken => {
  console.log('onGASetUserId');
  const userId = jwtDecode(accessToken)?.sub;
  //   console.log('[enabled]', router.app.$gtm.enabled());
  if (router.app.$gtm.enabled()) {
    const datalayer = window.dataLayer;
    // console.log('[datalayer], ', datalayer);
    // console.log('[GA]', userId);
    if (typeof datalayer !== 'undefined') {
      datalayer.push({
        event: 'setUserId',
        user_id: userId,
      });
    }
  }
};
